import { render, staticRenderFns } from "./UserMainPage.vue?vue&type=template&id=22564ab6&scoped=true&"
import script from "./UserMainPage.vue?vue&type=script&lang=js&"
export * from "./UserMainPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22564ab6",
  null
  
)

export default component.exports